/**
 * DERIVED — the JSON files beside this one are generated from `website/feature-pages/pro.md` in
 * the stippl-knowledge repo, so marketing can edit the /pro page's copy without a developer
 * (123yb6946ny). This namespace is called "pricing" and the page it serves is /pro: a real
 * mismatch, not a bug. Rebuild with `python3 tools/build_feature_pages.py pro` from
 * stippl-knowledge. Change English copy in the markdown, not in en.json: the next build stops on a
 * direct en.json edit and names it as drift. A direct fix to a translation survives until its
 * English changes.
 */
import en from "./en.json";
import nl from "./nl.json";
import de from "./de.json";
import fr from "./fr.json";
import es from "./es.json";
import it from "./it.json";
import pt from "./pt.json";
import { loadPageTranslations } from "../../loadPageTranslations";

const files = { en, nl, de, fr, es, it, pt };

export function getPricingTranslations(lang: string): Record<string, string> {
	return loadPageTranslations(files, lang);
}
